import { Navbar } from "@/components/Navbar";
import { PageBackground } from "@/components/PageBackground";

const SECTION = "font-display text-xl font-semibold tracking-tight mt-8 mb-2";

export default function Privacy() {
  const updated = "July 2, 2026";
  return (
    <div className="min-h-screen">
      <PageBackground variant={1} />
      <Navbar />
      <div className="max-w-3xl mx-auto px-6 md:px-8 py-12" data-testid="privacy-page">
        <h1 className="font-display text-4xl font-semibold tracking-tight">Privacy Policy</h1>
        <p className="text-muted-foreground mt-2">Last updated: {updated}</p>

        <p className="mt-6 text-base leading-relaxed">
          MyRentalMatch ("we", "us") operates the RentMatch web and mobile applications (the "Service").
          This policy explains what we collect, how we use it, and your choices. By using the Service you agree to this policy.
        </p>

        <h2 className={SECTION}>Information we collect</h2>
        <ul className="list-disc pl-6 space-y-1 text-base leading-relaxed">
          <li><b>Account data:</b> name, email, password (stored hashed), and role (tenant or landlord).</li>
          <li><b>Profile data:</b> rental preferences, budget, desired areas, amenities, household size, and address for distance matching.</li>
          <li><b>Verification data:</b> results of screening/credit/ID checks used to mark a profile verified.</li>
          <li><b>Usage data:</b> offers, matches, messages, and device push tokens (mobile) to deliver notifications.</li>
          <li><b>Payment data:</b> processed securely by Stripe. We do not store card numbers.</li>
        </ul>

        <h2 className={SECTION}>How we use information</h2>
        <ul className="list-disc pl-6 space-y-1 text-base leading-relaxed">
          <li>To match verified tenants with relevant landlord offers and properties.</li>
          <li>To operate messaging, verification, matchmaking, and payments.</li>
          <li>To send transactional emails and push notifications about offers and messages.</li>
          <li>To secure accounts and prevent fraud or abuse.</li>
        </ul>

        <h2 className={SECTION}>Sharing</h2>
        <p className="text-base leading-relaxed">
          We share limited profile details with landlords so they can send you offers. We use service providers
          (e.g., Stripe for payments, email/push delivery) who process data on our behalf. We do not sell your personal data.
        </p>

        <h2 className={SECTION}>Data retention & security</h2>
        <p className="text-base leading-relaxed">
          We retain data while your account is active and as needed for legal and operational purposes. Sessions use secure,
          httpOnly cookies. You can request deletion of your account and associated data at any time.
        </p>

        <h2 className={SECTION}>Your rights</h2>
        <p className="text-base leading-relaxed">
          You may access, correct, export, or delete your personal information, and opt out of push notifications in your device settings.
          To exercise these rights, contact us below.
        </p>

        <h2 className={SECTION}>Contact</h2>
        <p className="text-base leading-relaxed">
          Questions about privacy? Email <a className="text-primary font-medium" href="mailto:myrentalmatch@gmail.com">myrentalmatch@gmail.com</a>.
        </p>
      </div>
    </div>
  );
}
